import styled from 'styled-components'

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8} 0 ${props => props.theme.spacing.sp24} 0;
  width: 640px;
  height: 100vh;
`
